import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Sidebar from '../components/Layout/Sidebar';

// Dashboard Pages
import DashboardHome from './Dashboard/DashboardHome';
import Projects from './Dashboard/Projects';
import Prospects from './Dashboard/Prospects';
import Analytics from './Dashboard/Analytics';
import Settings from './Dashboard/Settings';

const Dashboard = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto">
          <Routes>
            <Route index element={<DashboardHome />} />
            <Route path="projects/*" element={<Projects />} />
            <Route path="prospects" element={<Prospects />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;